export default __webpack_public_path__ + "static/media/ten.b7ebed44.jpeg";